/*
  Rahu Care Hair Routine Quiz - storefront client
  ------------------------------------------------------------------
  Asks the questions, POSTs the answers to the app proxy
  (consultation-api/api/proxy/routine.js), then reveals the theme
  product cards the section pre-rendered for the recommended products.
  The scoring lives server-side in consultation-api/lib/routine.js;
  question ids and option values here must match it.

  Also exposes window.RahuRoutine.addToCart(items, sourceElement) and
  binds [data-hrq-add-routine] buttons (used on the account page).
*/

(() => {
  'use strict';

  // Shopify updates the document language when the storefront locale changes.
  const isEstonian = (document.documentElement.lang || window.Shopify?.locale || 'en').toLowerCase().split('-')[0] === 'et';
  const ET = {
    "Your scalp": "Sinu peanahk",
    "Your hair": "Sinu juuksed",
    "Your goal": "Sinu eesmärk",
    "Your routine": "Sinu juuksehooldus",
    "Last one": "Viimane küsimus",
    "How does your scalp usually feel?": "Milline on sinu peanahk tavaliselt?",
    "Think about the day after washing.": "Mõtle pesujärgsele päevale.",
    "Gets oily quickly": "Muutub kiiresti rasuseks",
    "Balanced - no real complaints": "Tasakaalus – erilisi muresid pole",
    "Dry or tight": "Kuiv või kiskuv",
    "Flaky or itchy": "Ketendav või sügelev",
    "Sensitive, red or easily irritated": "Tundlik, punetav või kergesti ärrituv",
    "How would you describe a single strand of your hair?": "Kuidas kirjeldaksid oma juuksekarva?",
    "Fine - delicate, falls flat easily": "Peenike – õrn ja kaotab kergesti kohevuse",
    "Medium - average thickness": "Keskmise jämedusega",
    "Thick or coarse": "Jäme või tugev",
    "What is your natural hair texture?": "Milline on sinu juuste loomulik tekstuur?",
    "Straight": "Sirged",
    "Wavy": "Lainelised",
    "Curly": "Lokkis",
    "Coily": "Tihedalt krussis",
    "Is your hair coloured or chemically treated?": "Kas sinu juuksed on värvitud või keemiliselt töödeldud?",
    "No - natural, untreated": "Ei – loomulikud ja töötlemata",
    "Coloured or highlighted": "Värvitud või triibutatud",
    "Bleached or lightened": "Pleegitatud või heledamaks värvitud",
    "Permed, relaxed or chemically straightened": "Keemiliselt lokitud või sirgendatud",
    "What would you most like to change?": "Mida sooviksid kõige rohkem muuta?",
    "More volume and lightness": "Rohkem kohevust ja kergust",
    "Repair dryness and damage": "Leevendada kuivust ja kahjustusi",
    "A healthier scalp and stronger growth": "Tervem peanahk ja tugevam juuksekasv",
    "More softness and shine": "Rohkem pehmust ja sära",
    "A deep, fresh clean": "Sügav ja värskendav puhastus",
    "How often do you wash your hair?": "Kui tihti sa juukseid pesed?",
    "Every day or almost": "Iga päev või peaaegu iga päev",
    "Every 2-3 days": "Iga 2–3 päeva järel",
    "Once a week or less": "Kord nädalas või harvem",
    "Do you use styling products or live with hard water?": "Kas kasutad soengutooteid või on sinu kodus kare vesi?",
    "Both leave residue that a gentle wash can’t always lift.": "Mõlemad võivad jätta jääke, mida õrn pesu alati ei eemalda.",
    "Yes, regularly": "Jah, regulaarselt",
    "Sometimes": "Mõnikord",
    "Rarely or never": "Harva või mitte kunagi",
    "How would you like your bars?": "Millises pakendis soovid oma tahkeid tooteid?",
    "Same bar, same price difference you see in the shop.": "Sama toode, sama hinnavahe nagu e-poes.",
    "Naked - zero packaging": "Ilma pakendita",
    "In the environment-friendly package": "Keskkonnasõbralikus pakendis",
    "Back": "Tagasi",
    "First name": "Eesnimi",
    "Email": "E-post",
    "Your routine is ready": "Sinu hooldusrutiin on valmis",
    "Save it for later?": "Kas salvestame selle?",
    "Leave your email and we’ll keep your routine on file - it will be waiting in your account the next time you visit.": "Jäta oma e-posti aadress ja salvestame sinu hooldusrutiini. Järgmisel külastusel ootab see sind sinu kontol.",
    "Save & show my routine": "Salvesta ja näita minu hooldusrutiini",
    "Skip - show my routine": "Jäta vahele ja näita minu hooldusrutiini",
    "Please enter a valid email - or skip this step.": "Sisesta kehtiv e-posti aadress või jäta see samm vahele.",
    "Preparing your routine…": "Koostame sinu hooldusrutiini…",
    "We couldn’t prepare your routine just now. Please try again.": "Hooldusrutiini koostamine ei õnnestunud. Palun proovi uuesti.",
    "Welcome back - your saved routine": "Tere tulemast tagasi – sinu salvestatud hooldusrutiin",
    "Your personal routine": "Sinu personaalne hooldusrutiin",
    "We couldn’t save your routine to your account just now - here it is. Retake the quiz later to save it.": "Hooldusrutiini salvestamine sinu kontole ei õnnestunud. Siin on sinu tulemus. Salvestamiseks täida küsimustik hiljem uuesti.",
    "We couldn’t save your routine just now - here it is, and you can try saving again below.": "Hooldusrutiini salvestamine ei õnnestunud. Siin on sinu tulemus. Allpool saad uuesti proovida.",
    "Saved to your account.": "Salvestatud sinu kontole.",
    "Saved - we’ll keep it on file for you.": "Salvestatud – sinu hooldusrutiin ootab sind järgmisel korral.",
    "Keep your routine": "Hoia oma hooldusrutiin alles",
    "Save these results to come back to them any time.": "Salvesta tulemused, et saaksid nende juurde alati tagasi tulla.",
    "Save my routine": "Salvesta minu hooldusrutiin",
    "Please enter a valid email.": "Sisesta kehtiv e-posti aadress.",
    "We couldn’t save your routine just now. Please try again.": "Hooldusrutiini salvestamine ei õnnestunud. Palun proovi uuesti.",
    "Saved - your routine is on file for you.": "Salvestatud – sinu hooldusrutiin on alles.",
    "Could not add your routine to the cart.": "Hooldusrutiini ostukorvi lisamine ei õnnestunud.",
    "Also send me Rahu Care hair tips and offers.": "Soovin saada ka Rahu Care’i juuksehooldusnõuandeid ja pakkumisi.",
    "Charcoal and black clay lift residue and buildup without stripping your hair.": "Süsi ja must savi eemaldavad jäägid ja kogunenud mustuse juukseid liigselt kuivatamata.",
    "Charcoal and black clay reset a scalp that gets oily quickly, so your hair stays fresh for longer.": "Süsi ja must savi puhastavad kiiresti rasuseks muutuva peanaha, et juuksed püsiksid kauem värsked.",
    "The deep, fresh clean you asked for - charcoal and black clay lift residue without stripping.": "Sinu soovitud sügav ja värske puhastus – süsi ja must savi eemaldavad jäägid juukseid liigselt kuivatamata.",
    "Clears styling product and hard-water buildup that leaves hair dull and heavy.": "Eemaldab soengutoodete ja kareda vee jäägid, mis muudavad juuksed tuhmiks ja raskeks.",
    "A dermatologically tested prebiotic formula that keeps your scalp calm and balanced.": "Dermatoloogiliselt testitud prebiootiline koostis aitab hoida peanaha rahuliku ja tasakaalus.",
    "Salicylic acid gently exfoliates flakes while rosemary and sea kelp soothe itching.": "Salitsüülhape koorib õrnalt ketendust, rosmariin ja pruunvetikas leevendavad sügelust.",
    "Rosemary and sea kelp bioferment calm a sensitive, reddened scalp. Dermatologically tested.": "Rosmariin ja pruunvetika bioferment rahustavad tundlikku ja punetavat peanahka. Dermatoloogiliselt testitud.",
    "Starts a healthier scalp routine - gently exfoliating, soothing and balancing.": "Esimene samm tervema peanaha suunas – õrn koorimine, rahustamine ja tasakaalustamine.",
    "A nourishing prebiotic shampoo that moisturises and strengthens dry or treated hair.": "Toitev prebiootiline šampoon niisutab ja tugevdab kuivi või töödeldud juukseid.",
    "Made for coloured hair - hyaluronic acid keeps moisture in and strands feeling thicker.": "Loodud värvitud juustele – hüaluroonhape aitab säilitada niiskust ja muudab juuksed lopsakamaks.",
    "Made for lightened hair - hyaluronic acid restores moisture and strengthens each strand.": "Loodud heledaks töödeldud juustele – hüaluroonhape taastab niiskust ja tugevdab iga juuksekarva.",
    "Made for chemically treated hair - it moisturises and strengthens without weighing hair down.": "Loodud keemiliselt töödeldud juustele – niisutab ja tugevdab juukseid raskeks muutmata.",
    "Repairs dryness and damage with hyaluronic acid and a nourishing prebiotic base.": "Hüaluroonhape ja toitev prebiootiline koostis aitavad leevendada kuivust ja kahjustusi.",
    "Rebalances a dry, tight scalp while moisturising your lengths.": "Aitab tasakaalustada kuiva ja kiskuvat peanahka ning niisutab juuksepikkusi.",
    "A gentle everyday prebiotic cleanse - maca extract leaves hair with bounce.": "Õrn prebiootiline puhastus igaks päevaks – makaekstrakt annab juustele elastsust.",
    "A gentle everyday cleanse for a balanced scalp - maca extract supports density and bounce.": "Õrn igapäevane puhastus tasakaalus peanahale – makaekstrakt toetab juuste tihedust ja elastsust.",
    "Maca extract supports stronger growth and density with every wash.": "Makaekstrakt toetab iga pesuga tugevamat juuksekasvu ja tihedust.",
    "Detangles and restores shine without buildup or weighing hair down.": "Harutab pusad lahti ja taastab sära, jätmata jääke ega muutes juukseid raskeks.",
    "Light enough for fine hair - it detangles and adds shine without weighing it down.": "Piisavalt kerge peentele juustele – harutab pusad ja lisab sära juukseid raskeks muutmata.",
    "A volume-boosting conditioner that leaves hair light, soft and full.": "Kohevust lisav palsam jätab juuksed kergeks, pehmeks ja lopsakaks.",
    "Moisturises, softens and fights static in dry or treated hair.": "Niisutab ja pehmendab kuivi või töödeldud juukseid ning vähendab staatilist elektrit.",
    "Rich enough for thick or coarse hair - it softens, detangles and fights static.": "Piisavalt rikkalik jämedatele juustele – pehmendab, harutab pusad ja vähendab staatilist elektrit.",
    "Gives curls slip and moisture so they detangle easily and hold their shape.": "Annab lokkidele niiskust ja libedust, et neid oleks lihtne lahti harutada ning need hoiaksid kuju.",
    "Gives coils the moisture and slip they need to detangle without breakage.": "Annab tihedatele lokkidele niiskust ja libedust, et pusad saaks lahti harutada juukseid lõhkumata.",
    "Proteins and fatty acids restore softness to lightened hair.": "Valgud ja rasvhapped taastavad heledaks töödeldud juuste pehmuse.",
    "Proteins and fatty acids restore softness to chemically treated hair.": "Valgud ja rasvhapped taastavad keemiliselt töödeldud juuste pehmuse.",
    "Proteins and fatty acids help repair dryness and damage between washes.": "Valgud ja rasvhapped aitavad pesukordade vahel leevendada kuivust ja kahjustusi.",
    "Rosemary and amaranth oils nourish the scalp before you wash.": "Rosmariini- ja amarandiõli toidavad peanahka enne pesu.",
    "A pre-wash ritual for a dry, tight scalp - rosemary and amaranth oils restore nourishment.": "Pesueelne rituaal kuivale ja kiskuvale peanahale – rosmariini- ja amarandiõli toidavad peanahka.",
    "Rosemary oil supports scalp circulation for a healthy environment for growth.": "Rosmariiniõli toetab peanaha vereringet ja loob juuksekasvuks soodsa keskkonna.",
    "A jade scalp comb that stimulates microcirculation and helps your care absorb deeper.": "Jadekivist peanahakamm stimuleerib mikrovereringet ja aitab hooldustoodetel paremini imenduda.",
    "Daily scalp massage with jade stimulates microcirculation to support growth.": "Igapäevane peanahamassaaž jadekiviga stimuleerib mikrovereringet ja toetab juuksekasvu.",
    "Rice and tapioca powders refresh roots between washes without buildup.": "Riisi- ja tapiokipulber värskendavad juuksejuuri pesukordade vahel, jätmata jääke.",
    "Absorbs excess oil between washes, so you can wash less often.": "Imab pesukordade vahel liigse rasu, et saaksid juukseid harvem pesta.",
    "Stretches the time between washes - rice and tapioca absorb oil, charcoal lifts impurities.": "Pikendab pesukordade vahet – riis ja tapiokk imavad rasu, süsi eemaldab mustuse.",
    "Your scalp routine in one set: GUA SHA comb, PRE-WASH oil and SCALP shampoo - for less than buying them separately.": "Sinu peanahahooldus ühes komplektis: GUA SHA kamm, PRE-WASH õli ja SCALP šampoon – soodsamalt kui eraldi ostes."
};
  const t = (text) => isEstonian ? (ET[text] || text) : text;

  function estonianProfile(answers = {}) {
    const strand = { A: 'Peenikesed', B: 'Keskmise jämedusega', C: 'Jämedad' };
    const texture = { A: 'sirged', B: 'lainelised', C: 'lokkis', D: 'tihedalt krussis' };
    const treated = { A: '', B: 'värvitud', C: 'heledaks töödeldud', D: 'keemiliselt töödeldud' };
    const scalp = { A: 'rasune', B: 'tasakaalus', C: 'kuiv', D: 'ketendav', E: 'tundlik' };
    if (!strand[answers.strand] || !texture[answers.texture] || !scalp[answers.scalp]) return t('Your personal routine');
    return `${[strand[answers.strand], texture[answers.texture], treated[answers.treated]].filter(Boolean).join(', ')} juuksed · ${scalp[answers.scalp]} peanahk`;
  }

  const svg = (paths) => `<svg class="hair-experience__icon" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths}</svg>`;
  const ICONS = {
    straight: svg('<path d="M14 6v36M24 6v36M34 6v36"/>'),
    wavy: svg('<path d="M14 6c-6 5 6 10 0 15s6 10 0 15"/><path d="M24 6c-6 5 6 10 0 15s6 10 0 15"/><path d="M34 6c-6 5 6 10 0 15s6 10 0 15"/>'),
    curly: svg('<path d="M16 8c8 0 8 8 0 8s-8 8 0 8 8 8 0 8"/><path d="M30 8c8 0 8 8 0 8s-8 8 0 8 8 8 0 8"/>'),
    coily: svg('<path d="M13 6l8 5-8 5 8 5-8 5 8 5-8 5"/><path d="M31 6l-8 5 8 5-8 5 8 5-8 5 8 5"/>'),
  };

  // UI only - values (A-E) must match consultation-api/lib/routine.js.
  const QUESTIONS = [
    { id: 'scalp', eyebrow: t('Your scalp'), question: t('How does your scalp usually feel?'), hint: t('Think about the day after washing.'),
      options: [
        { value: 'A', label: t('Gets oily quickly') },
        { value: 'B', label: t('Balanced - no real complaints') },
        { value: 'C', label: t('Dry or tight') },
        { value: 'D', label: t('Flaky or itchy') },
        { value: 'E', label: t('Sensitive, red or easily irritated') },
      ] },
    { id: 'strand', eyebrow: t('Your hair'), question: t('How would you describe a single strand of your hair?'), hint: '',
      options: [
        { value: 'A', label: t('Fine - delicate, falls flat easily') },
        { value: 'B', label: t('Medium - average thickness') },
        { value: 'C', label: t('Thick or coarse') },
      ] },
    { id: 'texture', eyebrow: t('Your hair'), question: t('What is your natural hair texture?'), hint: '',
      options: [
        { value: 'A', label: t('Straight'), icon: ICONS.straight },
        { value: 'B', label: t('Wavy'), icon: ICONS.wavy },
        { value: 'C', label: t('Curly'), icon: ICONS.curly },
        { value: 'D', label: t('Coily'), icon: ICONS.coily },
      ] },
    { id: 'treated', eyebrow: t('Your hair'), question: t('Is your hair coloured or chemically treated?'), hint: '',
      options: [
        { value: 'A', label: t('No - natural, untreated') },
        { value: 'B', label: t('Coloured or highlighted') },
        { value: 'C', label: t('Bleached or lightened') },
        { value: 'D', label: t('Permed, relaxed or chemically straightened') },
      ] },
    { id: 'goal', eyebrow: t('Your goal'), question: t('What would you most like to change?'), hint: '',
      options: [
        { value: 'A', label: t('More volume and lightness') },
        { value: 'B', label: t('Repair dryness and damage') },
        { value: 'C', label: t('A healthier scalp and stronger growth') },
        { value: 'D', label: t('More softness and shine') },
        { value: 'E', label: t('A deep, fresh clean') },
      ] },
    { id: 'wash', eyebrow: t('Your routine'), question: t('How often do you wash your hair?'), hint: '',
      options: [
        { value: 'A', label: t('Every day or almost') },
        { value: 'B', label: t('Every 2-3 days') },
        { value: 'C', label: t('Once a week or less') },
      ] },
    { id: 'buildup', eyebrow: t('Your routine'), question: t('Do you use styling products or live with hard water?'), hint: t('Both leave residue that a gentle wash can’t always lift.'),
      options: [
        { value: 'A', label: t('Yes, regularly') },
        { value: 'B', label: t('Sometimes') },
        { value: 'C', label: t('Rarely or never') },
      ] },
    { id: 'packaging', eyebrow: t('Last one'), question: t('How would you like your bars?'), hint: t('Same bar, same price difference you see in the shop.'),
      options: [
        { value: 'A', label: t('Naked - zero packaging') },
        { value: 'B', label: t('In the environment-friendly package') },
      ] },
  ];

  const STORAGE_KEY = 'rahu:hair-routine';
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ------------------------------ helpers ------------------------------ */

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function readJson(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  function store(value) {
    try {
      if (value) window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
      else window.localStorage.removeItem(STORAGE_KEY);
    } catch { /* storage unavailable (private mode) - results still work */ }
  }

  function stored() {
    try { return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null'); } catch { return null; }
  }

  // Answers travel in the URL as one letter per question, in order (e.g. ?r=BACADBCA),
  // so a result can be reloaded or shared.
  function encodeAnswers(answers) {
    return QUESTIONS.map((q) => answers[q.id] || '').join('');
  }

  function decodeAnswers(code) {
    if (typeof code !== 'string' || code.length !== QUESTIONS.length) return null;
    const answers = {};
    for (let i = 0; i < QUESTIONS.length; i += 1) {
      const q = QUESTIONS[i];
      if (!q.options.some((o) => o.value === code[i])) return null;
      answers[q.id] = code[i];
    }
    return answers;
  }

  function setUrlCode(code) {
    try {
      const url = new URL(window.location.href);
      if (code) url.searchParams.set('r', code); else url.searchParams.delete('r');
      window.history.replaceState(window.history.state, '', url.toString());
    } catch { /* ignore */ }
  }

  // Minimal Shopify money formatter using the shop's money format.
  function formatMoney(cents) {
    const format = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '€{{amount_with_comma_separator}}';
    const fixed = (n, decimals, thousands, decimal) => {
      const [whole, frac] = (n / 100).toFixed(decimals).split('.');
      return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => ({
      amount: fixed(cents, 2, ',', '.'),
      amount_no_decimals: fixed(cents, 0, ',', '.'),
      amount_with_comma_separator: fixed(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: fixed(cents, 0, '.', ','),
      amount_with_space_separator: fixed(cents, 2, ' ', ','),
      amount_with_apostrophe_separator: fixed(cents, 2, "'", '.'),
    }[key] || fixed(cents, 2, ',', '.')));
  }

  /* ------------------------------ cart ------------------------------ */

  // Mirrors the theme's own product form (assets/theme.js, ProductForm):
  // bundle the cart sections, add, then fire the events that refresh the
  // cart count and open the cart drawer.
  async function addToCart(items, sourceEl) {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    try {
      const res = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items, sections: sections.join(','), sections_url: window.location.pathname }),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json.description || json.message || t('Could not add your routine to the cart.'));

      const settings = (window.themeVariables && window.themeVariables.settings) || {};
      if (settings.cartType === 'page' || settings.pageType === 'cart') { window.location.href = `${root()}cart`; return; }

      const cart = await (await fetch(`${root()}cart.js`)).json();
      cart.sections = json.sections;
      (sourceEl || document.documentElement).dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true, detail: { items: json.items || [json], cart },
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true, detail: { baseEvent: 'variant:add', cart },
      }));
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }

  function lineItem(variantId) {
    return { id: Number(variantId), quantity: 1, properties: { _source: 'Hair routine quiz' } };
  }

  async function runAddButton(btn, items, errorEl) {
    if (!items.length) return;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    if (errorEl) errorEl.hidden = true;
    try {
      await addToCart(items, btn);
    } catch (e) {
      if (errorEl) { errorEl.textContent = isEstonian ? t('Could not add your routine to the cart.') : e.message; errorEl.hidden = false; }
    } finally {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  }

  /* ------------------------------ quiz ------------------------------ */

  class HairRoutineQuiz {
    constructor(el) {
      this.el = el;
      this.isHomepage = el.dataset.pageType === 'index';
      // App proxies use their configured absolute path, independently of the
      // storefront language. Shopify's localized root is only for cart URLs.
      this.endpoint = el.dataset.endpoint || '/apps/rahu/routine';
      this.isMember = el.dataset.member === 'true';
      this.consentLabel = el.dataset.consent || t('Also send me Rahu Care hair tips and offers.');
      this.privacyNote = el.dataset.privacy || '';
      this.products = readJson(el.querySelector('[data-hrq-products]')) || {};
      const productIds = readJson(el.querySelector('[data-hrq-product-ids]')) || {};
      const byId = new Map(Object.values(this.products).map((product) => [String(product.id), product]));
      for (const [handle, id] of Object.entries(productIds)) {
        const product = id != null && byId.get(String(id));
        if (product) this.products[handle] = product;
      }
      this.quiz = el.querySelector('[data-hrq-quiz]');
      this.results = el.querySelector('[data-hrq-results]');
      this.grid = el.querySelector('[data-hrq-grid]');
      this.state = { answers: {}, email: '', firstName: el.dataset.firstName || '', marketing: false, saved: false };
      this.routine = null;

      this.results.querySelector('[data-hrq-retake]').addEventListener('click', () => this.restart());
      this.results.querySelector('[data-hrq-add]').addEventListener('click', (e) => this.addRoutine(e.currentTarget));

      this.start();
    }

    // A routine to show straight away: one in the URL, the member's saved one,
    // or the last one taken on this device.
    async start() {
      // Embedded homepage quizzes must not turn the homepage into a result link.
      if (this.isHomepage) setUrlCode('');
      const fromUrl = this.isHomepage ? null : decodeAnswers(new URLSearchParams(window.location.search).get('r'));
      const saved = readJson(this.el.querySelector('[data-hrq-saved]'));
      const local = stored();

      if (fromUrl) {
        const cached = local && local.routine && encodeAnswers(local.routine.answers || {}) === encodeAnswers(fromUrl) ? local : null;
        if (cached) { this.showResults(cached.routine, { saved: cached.saved }); return; }
        this.state.answers = fromUrl;
        try {
          const data = await this.prepareRoutine({ answers: fromUrl, save: false });
          this.showResults(data.routine, { saved: false, shared: true });
        } catch {
          this.show(0);
        }
        return;
      }
      if (saved && saved.products && saved.products.length) { this.showResults(saved, { saved: 'member', returning: true, reveal: false }); return; }
      if (local && local.routine) { this.showResults(local.routine, { saved: local.saved, returning: true, reveal: false }); return; }
      this.show(0);
    }

    restart() {
      this.state.answers = {};
      this.routine = null;
      setUrlCode('');
      this.results.hidden = true;
      this.quiz.hidden = false;
      this.show(0);
    }

    steps() {
      const list = QUESTIONS.map((q) => ({ kind: 'question', q }));
      if (!this.isMember) list.push({ kind: 'save' });
      return list;
    }

    show(i) {
      const steps = this.steps();
      this.index = Math.max(0, Math.min(i, steps.length - 1));
      const step = steps[this.index];
      this.quiz.innerHTML = `
        <div class="hair-routine__progress-label"><span>${isEstonian ? "Sinu juuste heaolu" : "A little care, made personal"}</span><span>${Math.round(this.index / steps.length * 100)}%</span></div>
        <div class="hair-routine__meter" role="progressbar" aria-label="${isEstonian ? 'Küsimustiku edenemine' : 'Quiz progress'}" aria-valuemin="0" aria-valuemax="${steps.length}" aria-valuenow="${this.index}"><span style="width:${this.index / steps.length * 100}%"></span></div>
        <ol class="hair-experience__progress" aria-hidden="true">${steps.map((_, n) => `<li${n < this.index ? ' data-done' : ''}${n === this.index ? ' data-current' : ''}></li>`).join('')}</ol>
        <div class="hair-experience__body" aria-live="polite"></div>`;
      this.body = this.quiz.querySelector('.hair-experience__body');
      if (step.kind === 'question') this.showQuestion(step.q);
      else this.showSaveStep();
      if (i > 0) this.quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    navWrap(inner) {
      return `<section class="hair-experience__step" data-active>${inner}
        <div class="hair-experience__nav">
          <button type="button" class="hair-experience__back"${this.index > 0 ? '' : ' hidden'}>${escapeHtml(t("Back"))}</button>
        </div></section>`;
    }

    bindBack() {
      const back = this.body.querySelector('.hair-experience__back');
      if (back) back.addEventListener('click', () => { if (!this.advancing) this.show(this.index - 1); });
    }

    showQuestion(q) {
      const hasIcons = q.options.some((o) => o.icon);
      const layout = hasIcons ? ' hair-experience__options--two hair-experience__options--icons' : (q.options.length === 4 ? ' hair-experience__options--two' : '');
      const last = this.index === QUESTIONS.length - 1;
      this.body.innerHTML = this.navWrap(`
        <span class="hair-experience__eyebrow">${escapeHtml(q.eyebrow)} · ${this.index + 1} ${isEstonian ? "/" : "of"} ${QUESTIONS.length}</span>
        <h2 class="hair-experience__question h4" tabindex="-1">${escapeHtml(q.question)}</h2>
        ${q.hint ? `<p class="hair-experience__hint">${escapeHtml(q.hint)}</p>` : '<div style="height:1rem"></div>'}
        <div class="hair-experience__options${layout}" role="group" aria-label="${escapeHtml(q.question)}">
          ${q.options.map((o) => `
            <button type="button" class="hair-experience__option" data-value="${o.value}" aria-pressed="${this.state.answers[q.id] === o.value}">
              ${o.icon || ''}
              <span class="hair-experience__option-label">${escapeHtml(o.label)}</span>
            </button>`).join('')}
        </div>
        <p class="hair-experience__error" hidden></p>`);

      this.body.querySelectorAll('.hair-experience__option').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (this.advancing) return;
          this.advancing = true;
          this.state.answers[q.id] = btn.dataset.value;
          this.body.querySelectorAll('.hair-experience__option').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
          window.setTimeout(() => {
            this.advancing = false;
            // Members skip the save step: their routine is saved to their account.
            if (last && this.isMember) this.submit({});
            else this.show(this.index + 1);
          }, 200);
        });
      });
      this.bindBack();
      if (this.index > 0) this.body.querySelector('h2').focus({ preventScroll: true });
    }

    saveFields(idPrefix) {
      return `
        <div class="hair-experience__fields">
          <label class="hair-experience__field"><span>${escapeHtml(t("First name"))}</span>
            <input type="text" name="firstName" autocomplete="given-name" value="${escapeHtml(this.state.firstName)}"></label>
          <label class="hair-experience__field"><span>${escapeHtml(t("Email"))}</span>
            <input type="email" name="email" autocomplete="email" inputmode="email" value="${escapeHtml(this.state.email)}"></label>
          <label class="hair-routine__consent" for="${idPrefix}-marketing">
            <input type="checkbox" id="${idPrefix}-marketing" name="marketing"${this.state.marketing ? ' checked' : ''}>
            <span>${escapeHtml(this.consentLabel)}</span>
          </label>
          ${this.privacyNote ? `<p class="hair-routine__privacy">${escapeHtml(this.privacyNote)}</p>` : ''}
        </div>`;
    }

    readSaveFields(scope) {
      const email = scope.querySelector('input[name="email"]').value.trim();
      return {
        email,
        firstName: scope.querySelector('input[name="firstName"]').value.trim(),
        marketing: scope.querySelector('input[name="marketing"]').checked,
      };
    }

    // Soft email capture: optional, with "skip" as easy as "save".
    showSaveStep() {
      this.body.innerHTML = this.navWrap(`
        <span class="hair-experience__eyebrow">${escapeHtml(t("Your routine is ready"))}</span>
        <h2 class="hair-experience__question h4" tabindex="-1">${escapeHtml(t("Save it for later?"))}</h2>
        <p class="hair-experience__hint">${escapeHtml(t("Leave your email and we’ll keep your routine on file - it will be waiting in your account the next time you visit."))}</p>
        ${this.saveFields('hrq-step')}
        <div class="hair-routine__step-actions">
          <button type="button" class="button w-full" data-hrq-save>${escapeHtml(t("Save & show my routine"))}</button>
          <button type="button" class="button button--outline w-full" data-hrq-skip>${escapeHtml(t("Skip - show my routine"))}</button>
        </div>
        <p class="hair-experience__error" hidden></p>`);

      this.body.querySelector('[data-hrq-skip]').addEventListener('click', (e) => this.submit({}, e.currentTarget));
      this.body.querySelector('[data-hrq-save]').addEventListener('click', (e) => {
        const fields = this.readSaveFields(this.body);
        if (!EMAIL_RE.test(fields.email)) {
          this.showError(this.body, t('Please enter a valid email - or skip this step.'));
          this.body.querySelector('input[name="email"]').focus();
          return;
        }
        Object.assign(this.state, fields);
        this.submit(fields, e.currentTarget);
      });
      this.bindBack();
      this.body.querySelector('h2').focus({ preventScroll: true });
    }

    showError(scope, msg) {
      const el = scope.querySelector('.hair-experience__error');
      if (el) { el.textContent = msg; el.hidden = false; }
    }

    answerSummary(answers = this.state.answers) {
      return QUESTIONS.filter((q) => ['scalp', 'texture', 'goal'].includes(q.id))
        .map((q) => q.options.find((o) => o.value === answers[q.id])?.label)
        .filter(Boolean);
    }

    renderLoading() {
      this.quiz.hidden = false;
      this.results.hidden = true;
      this.quiz.innerHTML = `<section class="hair-routine__thinking" role="status" aria-live="polite">
        <div class="hair-routine__orbit" aria-hidden="true">${ICONS.wavy}</div>
        <span class="hair-experience__eyebrow">${isEstonian ? 'Loodud sinu jaoks' : 'Made around you'}</span>
        <h2 class="h4" tabindex="-1">${escapeHtml(t('Preparing your routine…'))}</h2>
        <p data-hrq-thinking>${isEstonian ? 'Vaatame sinu vastuseid…' : 'Reviewing your answers…'}</p>
        <div class="hair-routine__meter hair-routine__meter--thinking" aria-hidden="true"><span></span></div>
        <div class="hair-routine__traits">${this.answerSummary().map((label) => `<span>${escapeHtml(label)}</span>`).join('')}</div>
        <p class="hair-routine__thinking-note">${isEstonian ? 'Sinu peanahk, juuste tekstuur ja eesmärgid aitavad leida sobiva hoolduse.' : 'Your scalp, hair texture and goals guide the care we choose.'}</p>
      </section>`;
      this.quiz.querySelector('h2').focus({ preventScroll: true });
    }

    async prepareRoutine(payload) {
      this.renderLoading();
      const status = this.quiz.querySelector('[data-hrq-thinking]');
      const timer = window.setTimeout(() => {
        status.textContent = isEstonian ? 'Sobitame hoolduse sinu juuste ja peanaha vajadustega…' : 'Matching care to your hair and scalp needs…';
      }, 650);
      try {
        // Keep a brief, readable transition even when the server responds immediately.
        const [data] = await Promise.all([this.post(payload), new Promise((resolve) => window.setTimeout(resolve, 1400))]);
        status.textContent = t('Your routine is ready');
        this.quiz.querySelector('.hair-routine__meter').classList.add('hair-routine__meter--ready');
        await new Promise((resolve) => window.setTimeout(resolve, 300));
        return data;
      } finally {
        window.clearTimeout(timer);
      }
    }

    async post(payload) {
      const res = await fetch(this.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.ok || !data.routine) throw new Error(isEstonian ? t('We couldn’t prepare your routine just now. Please try again.') : (data.error || t('We couldn’t prepare your routine just now. Please try again.')));
      return data;
    }

    async submit(fields, btn) {
      if (this.submitting) return;
      this.submitting = true;
      try {
        const data = await this.prepareRoutine({ answers: this.state.answers, ...fields });
        const wantedSave = this.isMember || !!fields.email;
        this.showResults(data.routine, { saved: data.saved, saveFailed: wantedSave && !data.saved });
      } catch (e) {
        this.show(this.index);
        this.showError(this.body, e.message);
      } finally {
        this.submitting = false;
      }
    }

    /* ------------------------------ results ------------------------------ */

    variantFor(handle, packaging) {
      const p = this.products[handle];
      if (!p) return null;
      const v = p[packaging === 'package' ? 'package' : 'naked'];
      return v && v.available ? v : null;
    }

    showResults(routine, { saved = false, saveFailed = false, returning = false, shared = false, reveal = true } = {}) {
      this.routine = routine;
      this.state.saved = saved;
      if (routine.answers) {
        this.state.answers = { ...routine.answers };
        if (!this.isHomepage) setUrlCode(encodeAnswers(routine.answers));
      }
      if (!shared) store({ routine, saved, date: new Date().toISOString() });

      this.quiz.hidden = true;
      this.results.hidden = false;

      const eyebrow = this.results.querySelector('[data-hrq-eyebrow]');
      eyebrow.textContent = returning ? t('Welcome back - your saved routine') : t('Your personal routine');
      const profile = this.results.querySelector('[data-hrq-profile]');
      profile.textContent = isEstonian ? estonianProfile(routine.answers) : (routine.profile || t('Your routine'));

      let summary = this.results.querySelector('[data-hrq-summary]');
      if (!summary) {
        summary = document.createElement('div');
        summary.dataset.hrqSummary = '';
        summary.className = 'hair-routine__traits';
        profile.insertAdjacentElement('afterend', summary);
      }
      summary.innerHTML = this.answerSummary(routine.answers || {}).map((label) => `<span>${escapeHtml(label)}</span>`).join('');

      const notice = this.results.querySelector('[data-hrq-notice]');
      notice.hidden = true;
      if (saveFailed) {
        notice.textContent = this.isMember
          ? t('We couldn’t save your routine to your account just now - here it is. Retake the quiz later to save it.')
          : t('We couldn’t save your routine just now - here it is, and you can try saving again below.');
        notice.hidden = false;
      } else if (saved === 'member' && !returning) {
        notice.textContent = t('Saved to your account.');
        notice.hidden = false;
      } else if (saved === 'guest' && !returning) {
        notice.textContent = t('Saved - we’ll keep it on file for you.');
        notice.hidden = false;
      }

      // Reveal the recommended cards in routine order; hide the rest.
      const items = [...this.grid.querySelectorAll('[data-handle]')];
      items.forEach((item) => { item.hidden = true; });
      const shown = [];
      (routine.products || []).forEach((p) => {
        const product = this.products[p.handle];
        const item = items.find((el) => product?.id != null
          ? el.dataset.productId === String(product.id)
          : el.dataset.handle === p.handle);
        if (!item) { console.warn(`[hair-routine] "${p.handle}" is not in the section's product list`); return; }
        item.querySelector('[data-hrq-reason]').textContent = t(p.reason || '');
        item.hidden = false;
        this.grid.appendChild(item);
        shown.push(p.handle);
      });
      this.grid.dataset.count = String(shown.length);
      this.updateTotal(shown, routine.packaging);

      const oil = this.results.querySelector('[data-hrq-oil]');
      if (oil) oil.hidden = !routine.oilUpsell;
      const diagnostics = this.results.querySelector('[data-hrq-diagnostics]');
      if (diagnostics) diagnostics.hidden = !routine.diagnosticsSuggest;

      this.renderSaveCard(saved, saveFailed);
      if (reveal) {
        profile.focus({ preventScroll: true });
        this.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    routineItems() {
      const missing = [];
      const items = [];
      (this.routine.products || []).forEach((p) => {
        const v = this.variantFor(p.handle, this.routine.packaging);
        if (v) items.push(lineItem(v.id));
        else if (this.products[p.handle]) missing.push(this.products[p.handle].title);
      });
      return { items, missing };
    }

    updateTotal(handles, packaging) {
      const total = handles.reduce((sum, h) => {
        const v = this.variantFor(h, packaging);
        return sum + (v ? v.price : 0);
      }, 0);
      const btn = this.results.querySelector('[data-hrq-add]');
      this.results.querySelector('[data-hrq-total]').textContent = total ? ` · ${formatMoney(total)}` : '';
      btn.hidden = !total;
    }

    async addRoutine(btn) {
      const errorEl = this.results.querySelector('[data-hrq-cart-error]');
      const { items, missing } = this.routineItems();
      await runAddButton(btn, items, errorEl);
      if (missing.length && errorEl.hidden) {
        errorEl.textContent = isEstonian ? `Hooldusrutiin lisatud. Hetkel on välja müüdud: ${missing.join(', ')}.` : `Added your routine. ${missing.join(', ')} ${missing.length > 1 ? 'are' : 'is'} sold out right now.`;
        errorEl.hidden = false;
      }
    }

    // Guests who skipped (or whose save failed) get one more gentle chance.
    renderSaveCard(saved, saveFailed) {
      const card = this.results.querySelector('[data-hrq-save-card]');
      if (this.isMember || (saved && !saveFailed)) { card.hidden = true; card.innerHTML = ''; return; }
      card.hidden = false;
      card.innerHTML = `
        <span class="hair-experience__eyebrow">${escapeHtml(t("Keep your routine"))}</span>
        <p class="h5">${escapeHtml(t("Save these results to come back to them any time."))}</p>
        ${this.saveFields('hrq-card')}
        <button type="button" class="button button--outline w-full" data-hrq-card-save>${escapeHtml(t("Save my routine"))}</button>
        <p class="hair-experience__error" hidden></p>`;
      card.querySelector('[data-hrq-card-save]').addEventListener('click', async (e) => {
        const btn = e.currentTarget;
        const fields = this.readSaveFields(card);
        if (!EMAIL_RE.test(fields.email)) { this.showError(card, t('Please enter a valid email.')); return; }
        Object.assign(this.state, fields);
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        try {
          const data = await this.post({ answers: this.state.answers, ...fields });
          if (!data.saved) throw new Error(t('We couldn’t save your routine just now. Please try again.'));
          store({ routine: this.routine, saved: data.saved, date: new Date().toISOString() });
          card.innerHTML = `<p class="hair-routine__saved">${escapeHtml(t("Saved - your routine is on file for you."))}</p>`;
        } catch (err) {
          this.showError(card, err.message);
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        }
      });
    }
  }

  /* ------------------------------ init ------------------------------ */

  function bindAddButtons() {
    document.querySelectorAll('[data-hrq-add-routine]').forEach((btn) => {
      if (btn.dataset.hrqBound) return;
      btn.dataset.hrqBound = '1';
      btn.addEventListener('click', () => {
        let ids = [];
        try { ids = JSON.parse(btn.dataset.variants || '[]'); } catch { ids = []; }
        const errorEl = btn.parentElement.querySelector('[data-hrq-cart-error]');
        runAddButton(btn, ids.filter(Boolean).map(lineItem), errorEl);
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-hair-routine]').forEach((el) => {
      if (!el.dataset.hrqInit) { el.dataset.hrqInit = '1'; new HairRoutineQuiz(el); }
    });
    bindAddButtons();
  }

  window.RahuRoutine = { addToCart, QUESTIONS };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
